export {SelectionManager} from '../../../src/selection/SelectionManager';
